import { type PropsWithChildren } from "react";
import "./Iris.css";
import { cn } from "@/utils";

export type IrisStatus = 'open' | 'shrink' | 'transparent';
export type IrisColor = 'primary' | 'error';
interface IrisProps {
    status: IrisStatus;
    color: IrisColor;
    hidden?: boolean;
    appState: boolean;  
}
export const Iris = ({ status, color, children, hidden, appState }: PropsWithChildren<IrisProps>) => {
    const colorMap = {
        primary: 'primary-400',
        error: 'error-500',
    }

    return (
        <div style={{ display: hidden ? 'none': 'block' }}
            className={cn('iris', status,
                appState && status !== 'transparent' ? `bg-${colorMap[color]}` : ''
            )}
            data-testid="iris" >
            {children}
        </div>
    );
};
